import { Injectable } from '@angular/core';
import { DatasourceTableJobQuery } from '@y42/datasource';
import { DateTimeService } from '@y42/date-time';
import { OrgUserQuery } from '@y42/org-user/state';
import { IntegrationTableStoreQuery } from '../datasource-table/integration-table.store-query';
import { IntegrationStoreQuery } from '../datasource/integration.store-query';
import { IntegrationJobSettingsValidationService } from './integration-job-settings-validation/integration-job-settings-validation.service';
import { IntegrationTableJobStore } from './integration-table-job.store';

@Injectable({ providedIn: 'root' })
export class IntegrationTableJobQuery extends DatasourceTableJobQuery {
  constructor(
    store: IntegrationTableJobStore,
    dateTimeService: DateTimeService,
    grandParentQuery: IntegrationStoreQuery,
    parentQuery: IntegrationTableStoreQuery,
    orgUserQuery: OrgUserQuery,
    jobSettingsValidationService: IntegrationJobSettingsValidationService,
  ) {
    super(store, dateTimeService, grandParentQuery, parentQuery, orgUserQuery, jobSettingsValidationService);
  }
}
